import React, { useState, useRef, forwardRef, useEffect } from "react";
import { toast } from "react-toastify";
import axios from "axios";
import TextField from "@mui/material/TextField";
import { useNavigate } from "react-router-dom";
import { NumericFormat } from "react-number-format";
import { BarLoader } from "react-spinners";
import "../css/AddProject.css";
import { pink } from "@mui/material/colors";
import Switch from "@mui/material/Switch";
import {
  Box,
  Button,
  Divider,
  Modal,
  Tooltip,
  Typography,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import ImageIcon from "@mui/icons-material/Image";
import VideoLibraryIcon from "@mui/icons-material/VideoLibrary";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import DescriptionIcon from "@mui/icons-material/Description";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { IoIosClose } from "react-icons/io";
// import UploadImg from "../image/additional_upload.png";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";
import { styled } from "@mui/material/styles";
import { Home } from "@mui/icons-material";

const CustomConnector = styled(StepConnector)(({ theme }) => ({
  [`&.MuiStepConnector-alternativeLabel`]: {
    top: 10, // aligns with center of the custom icon (32px tall)
    left: "calc(-74% + 12px)",
    right: "calc(26% + 12px)",
  },
  [`& .MuiStepConnector-line`]: {
    height: 3,
    border: 0,
    backgroundColor: "lightgray",
    // borderRadius: 2,
  },
}));

const NumericFormatCustom = forwardRef(function NumericFormatCustom(
  props,
  ref
) {
  const { onChange, ...other } = props;

  return (
    <NumericFormat
      {...other}
      getInputRef={ref}
      style={{ padding: "6px" }}
      onValueChange={(values) => {
        const rawValue = values.value;

        const formattedValue =
          Number(rawValue) % 1 === 0
            ? Number(rawValue).toFixed(0)
            : Number(rawValue).toFixed(2);

        onChange({
          target: {
            name: props.name,
            value: formattedValue,
          },
        });
      }}
      isAllowed={(values) => {
        const { floatValue, formattedValue } = values;
        if (floatValue === undefined) return true;

        // Ensure no more than 13 digits before decimal and 2 after
        const parts = formattedValue.replace(/[^\d.]/g, "").split(".");
        const beforeDecimal = parts[0] || "";
        const afterDecimal = parts[1] || "";

        return beforeDecimal.length <= 13 && afterDecimal.length <= 2;
      }}
      thousandSeparator
      valueIsNumericString
      allowNegative={false}
      prefix="$"
    />
  );
});

const iframeStyle = {
  width: "100%",
  height: "-webkit-fill-available",
  height: "100vh",
  border: "none", // Remove iframe border if needed
};

function Inputs() {
  const navigate = useNavigate();
  const fileInputRef = useRef(null);
  const [inputList, setInputList] = useState([
    { Milestone: "", price: "", description: "", files: [] },
    { Milestone: "", price: "", description: "", files: [] },
    { Milestone: "", price: "", description: "", files: [] },
  ]);
  const [ownerOptions, setOwnerOptions] = useState([]);
  const ContractRef = useRef(null);

  useEffect(() => {
    if (projectNameInputRef) {
      projectNameInputRef?.current?.focus();
    }
    getOwnermails();
  }, []);

  const getOwnermails = async () => {
    try {
      const response = await axios.get("/cvault/owner-emails/", {
        headers: headers,
      });

      setOwnerOptions(response?.data?.owner_email_details || []);
    } catch (error) {
      toast.error(
        error?.response?.data?.error || "Unable to fetch the owner emails."
      );
    }
  };

  const projectNameInputRef = useRef(null);
  const emailInputRef = useRef(null);
  const [selectedPdf, setSelectedPdf] = useState(null);
  const [selectedPdfFile, setSelectedPdfFile] = useState(null);
  const [loader, setLoader] = useState(false);
  const [AImessage, setAImessage] = useState(false);
  const [pdfmilestone, setPdfmilestone] = useState([]);
  const [fileName, setFileName] = useState("");
  const [genAI, setGenAI] = useState(true);
  const [duplicateError, setDuplicateError] = useState({});
  const [projectUniqueError, setProjectUniqueError] = useState("");
  const [projectList, setProjectList] = useState([]);
  const [projectFiles, setProjectFiles] = useState([]);
  const [ProjectFileURLs, setProjectFileURLs] = useState([]);
  const [emailError, setEmailError] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [zipError, setZipError] = useState("");
  const [emptyFields, setEmptyFields] = useState(false);

  //for contract Milestone File modal
  const [ContractMilestoneFile, setContractMilestoneFile] = useState(false);
  const [selectedContractMilestoneFile, setSelectedContractMilestoneFile] =
    useState(null);
  const [MilestoneFileIndex, setMilestoneFileIndex] = useState(null);

  //for contract documents modal
  const [ContractDocuments, setContractDocuments] = useState(false);
  const [selectedContractDoc, setSelectedContractDoc] = useState(null);

  const iframeStyleContractDocs = {
    width: "100%",
    height: "80vh",
    border: "none", // Remove iframe border if needed
  };

  const [state, setState] = useState({
    name: "",
    owner_mail: "",
    project_budget: "0",
    month: "",
    date: "",
    address: "",
    city: "",
    state: "",
    zip: "",
    phone: "",
    owner_names: "",
    Co_owner: "",
  });

  const cookies = document.cookie.split("; ").reduce((acc, cookie) => {
    const [name, value] = cookie.split("=");
    acc[name] = decodeURIComponent(value);
    return acc;
  }, {});

  const headers = {
    "X-CSRFToken": cookies.csrftoken,
    "Content-Type": "multipart/form-data",
  };
  const [data, setData] = useState({});
  const [showAll, setShowAll] = useState(false);
  const [proshowAll, setProShowAll] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [activeStep, setActiveStep] = useState(0);

  // handle input change
  const handleInputChange = (e, index) => {
    const { name, value } = e.target;
    const trim_value = value.trimStart();
    const list = [...inputList];
    list[index][name] = trim_value;
    setInputList(list);
    if (name === "price") {
      const totalPrice = inputList
        .reduce((sum, item) => sum + (parseFloat(item.price) || 0), 0)
        .toFixed(2);
      const projectBudget = parseFloat(state.project_budget) || 0;
      setState((prev) => ({ ...prev, project_budget: totalPrice }));
    }

    setDuplicateError((prev) => {
      const updatedErrors = { ...prev };
      delete updatedErrors[index]; // Remove error for this specific index
      return updatedErrors;
    });
  };

  //duplicate milestone name check
  const handleDulpicateCheck = (e, index) => {
    const { name, value } = e.target;
    const list = [...inputList];
    if (name === "Milestone") {
      const milestoneNames = list.map((item, i) => ({
        name: item.Milestone,
        index: i,
      }));
      const isDuplicateFinal = milestoneNames.some(
        (item, i) =>
          item.name === value.trim() && item.name !== "" && i !== index
      );
      if (isDuplicateFinal) {
        setDuplicateError((prev) => ({
          ...prev,
          [index]: `Duplicate milestone found`,
        }));
      } else {
        setDuplicateError({});
      }
    }
  };

  // handle click event of the Remove button
  const handleRemoveClick = (index) => {
    const list = [...inputList];
    list.splice(index, 1);
    setInputList(list);
  };

  // handle click event of the Add button
  const handleAddClick = () => {
    setEmptyFields(false);
    setInputList([
      ...inputList,
      { price: "", Milestone: "", description: "", files: [] },
    ]);
  };

  const handleFileChange = async (e) => {
    setSelectedPdf(null);
    setSelectedPdfFile(null);
    const file = e.target.files[0];

    if (!file) return; // No file selected

    if (file.type !== "application/pdf") {
      toast.warning("Only contract document in .pdf format is allowed.");
      return;
    }

    setSelectedPdf(file);
    setFileName(file.name);
    milestonepdf(file);
    setAImessage(true);
    milestonepdfs(file);
    e.target.value = "";
  };
  //project file upload
  const handleProjectFileClick = () => {
    // if (
    //   state.name !== "" &&
    //   state.owner_mail !== "" &&
    //   state.project_budget !== "" &&
    //   state.month !== "" &&
    //   state.date !== "" &&
    //   state.address !== "" &&
    //   state.phone !== ""
    // ) {
    fileInputRef.current.click();
    //   setErrorMsg("");
    // } else {
    //   setErrorMsg("Please fill in all required fields.");
    // }
  };

  const handleProjectRomoveFile = (fileName) => {
    setProjectFileURLs((prevFiles) =>
      prevFiles.filter((file) => file.name !== fileName)
    );
    setProjectFiles((prevFiles) =>
      prevFiles.filter((file) => file.name !== fileName)
    );
  };

  const handleProjectFileUpload = (e) => {
    const selectedFiles = Array.from(e.target.files);
    const maxTotalSize = 200 * 1024 * 1024; // 200MB limit
    const allowedTypes = ["image", "video", "application/pdf", "text/plain"];

    let currentTotalSize = projectFiles.reduce(
      (acc, file) => acc + file.file.size,
      0
    );
    let validFiles = [];

    for (let file of selectedFiles) {
      if (projectFiles.some((f) => f.name === file.name)) {
        toast.warning(`File ${file.name} is already included.`);
        continue;
      }

      // if (!allowedTypes.some((type) => file.type.startsWith(type))) {
      //   toast.warning(`File type not supported: ${file.name}`);
      //   continue;
      // }

      if (currentTotalSize + file.size > maxTotalSize) {
        toast.warning(
          `Adding ${file.name} exceeds the maximum total file size limit of 200MB.`
        );
        break;
      }

      validFiles.push(file);
      currentTotalSize += file.size;
    }

    const newFiles = validFiles.map((file) => ({
      file,
      name: file.name,
      url: URL.createObjectURL(file), // ✅ Fix: Using `file` directly
      type: file.type.startsWith("image")
        ? "image"
        : file.type.startsWith("video")
        ? "video"
        : file.type === "application/pdf"
        ? "pdf"
        : file.type == "text/plain"
        ? "text"
        : "others",
      originalFile: file,
    }));

    setProjectFiles((prevFiles) => [...prevFiles, ...newFiles]);
    setProjectFileURLs((prevFiles) => [
      ...prevFiles,
      ...newFiles.map((f) => ({ name: f.name, url: f.url, type: f.type })),
    ]);

    e.target.value = "";
  };

  //Milestone file upload

  const fileInputRefs = useRef([]);

  const handleMilestoneFileClick = (index) => {
    if (fileInputRefs.current[index]) {
      fileInputRefs.current[index].click();
    }
  };

  const handleMilestoneRemoveFile = (index, fileName) => {
    setInputList((prevList) =>
      prevList.map((item, i) =>
        i === index
          ? {
              ...item,
              files: item.files.filter((file) => file.name !== fileName),
            }
          : item
      )
    );
  };

  const handleMilestoneFileUpload = (e, index) => {
    const selectedFiles = Array.from(e.target.files);
    const maxTotalSize = 200 * 1024 * 1024;
    const allowedTypes = ["image", "video", "application/pdf", "text/plain"];

    setInputList((prevList) =>
      prevList.map((item, i) => {
        if (i !== index) return item;

        const existingFiles = item.files || [];
        let currentTotalSize = existingFiles.reduce(
          (acc, file) => acc + file.file.size,
          0
        );
        let validFiles = [];

        for (let file of selectedFiles) {
          if (existingFiles.some((f) => f.name === file.name)) {
            toast.warning(`File ${file.name} is already included.`);
            continue;
          }

          // if (!allowedTypes.some((type) => file.type.startsWith(type))) {
          //   toast.warning(`File type not supported: ${file.name}`);
          //   continue;
          // }

          if (currentTotalSize + file.size > maxTotalSize) {
            toast.warning(`Adding ${file.name} exceeds the 200MB limit.`);
            break;
          }

          validFiles.push({
            file,
            name: file.name,
            url: URL.createObjectURL(file),
            type: file.type.startsWith("image")
              ? "image"
              : file.type.startsWith("video")
              ? "video"
              : file.type === "application/pdf"
              ? "pdf"
              : file.type === "text/plain"
              ? "text"
              : "others",
          });

          currentTotalSize += file.size;
        }

        return {
          ...item,
          files: [...existingFiles, ...validFiles], // Ensure files array exists
        };
      })
    );

    e.target.value = ""; // Reset input field
  };

  const genAIChange = async (event) => {
    setGenAI(event.target.checked);
  };
  const getProjectlist = async () => {
    try {
      var pData = await axios.get("/cvault/get-project-detail/");
      pData = pData?.data?.data?.map((project, index) => {
        return { ...project, id: index + 1 };
      });

      setProjectList(pData);
    } catch (error) {
      toast.error("Unable to retrieve project details. Please try again later");
    }
  };

  const milestonepdf = async (file) => {
    setLoader(true);
    setPdfmilestone([]);
    if (genAI) {
      try {
        const formData = new FormData();
        formData.set("pdf", file);

        const response = await axios.post(
          "/cvault/pdf-milestone-parser/",
          formData,
          {
            headers: headers,
          }
        );
        const pData = response;
        setData(response.data);
        setPdfmilestone(pData);
        setAImessage(false);
        setLoader(false);
      } catch (error) {
        setInputList([
          { Milestone: "", price: "", description: "", files: [] },
          { Milestone: "", price: "", description: "", files: [] },
          { Milestone: "", price: "", description: "", files: [] },
        ]);
        setLoader(false);
        setAImessage(false);

        if (
          error?.response?.data?.message
            ?.toLowerCase()
            .includes("you exceeded your current quota")
        ) {
          toast.error(
            "The AI function is currently not accessible, please update all the milestone details manually"
          );
        } else {
          toast.error(
            "Unable to fetch the required Milestone Information from the uploaded Contract. Please update all the required Milestone details manually"
          );
        }
      }
    } else {
      setLoader(false);
      setInputList([
        { Milestone: "", price: "", description: "", files: [] },
        { Milestone: "", price: "", description: "", files: [] },
        { Milestone: "", price: "", description: "", files: [] },
      ]);
      toast.warning(
        "Uploaded Contract opened in Viewer. Please update all the required Milestone details manually"
      );
    }
  };

  useEffect(() => {
    // Initialize the inputList with default values on page load
    setInputList([
      { Milestone: "", price: "", description: "", files: [] },
      { Milestone: "", price: "", description: "", files: [] },
      { Milestone: "", price: "", description: "", files: [] },
    ]);
    getProjectlist();
  }, []);

  useEffect(() => {
    const totalPrice = inputList
      .reduce((sum, item) => sum + (parseFloat(item.price) || 0), 0)
      .toFixed(2);

    setState((prev) => ({ ...prev, project_budget: totalPrice }));
  }, [inputList]);

  useEffect(() => {
    // Update inputList based on the data after the PDF is uploaded
    if (data && data?.length === 0) {
      setInputList([
        { Milestone: "", price: "", description: "", files: [] },
        { Milestone: "", price: "", description: "", files: [] },
        { Milestone: "", price: "", description: "", files: [] },
      ]);
    } else if (data && data?.data && data?.data.length !== 0) {
      setInputList(
        data?.data?.map((item) => ({
          price: item.price,
          Milestone: item.milestone,
          description: item?.description,
        }))
      );
    }
  }, [data]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name === "name") {
      handleUniquePrjName(value || state.name);
    }
    if (name === "phone") {
      if (value.length <= 10) {
        setState((prev) => ({ ...prev, [name]: value.trim() }));
      }
      return;
    }

    if (name === "zip") {
      if (value.length <= 5) {
        setState((prev) => ({ ...prev, [name]: value.trim() }));
      }
      return;
    }

    if (name === "month") {
      if (value.length <= 4) {
        const num = parseInt(value, 10);
        if (!isNaN(num) && num >= 1) {
          setState((prev) => ({ ...prev, [name]: num }));
        } else if (value === "") {
          setState((prev) => ({ ...prev, [name]: "" }));
        }
      }
      return;
    }

    if (name === "date") {
      const num = parseInt(value, 10);
      if (!isNaN(num) && num >= 1 && num <= 30) {
        setState((prev) => ({ ...prev, [name]: num }));
      } else if (value === "") {
        setState((prev) => ({ ...prev, [name]: "" }));
      }
      return;
    }

    // Default trimming
    const sanitizedValue =
      name === "owner_mail" ? value.trim().toLowerCase() : value.trimStart();

    setState((prev) => ({ ...prev, [name]: sanitizedValue }));
  };

  const handleUniquePrjName = (name) => {
    const isDuplicate = projectList.some(
      (proj) => proj.name.toLowerCase() === name.toLowerCase().trimEnd()
    );
    if (isDuplicate) {
      setProjectUniqueError(
        "Project name already exists. Please choose a different name."
      );
    } else {
      setProjectUniqueError("");
    }
  };

  const handleSubmit = async (next = false) => {
    const totalPrice = parseFloat(
      inputList
        .reduce((sum, item) => sum + (parseFloat(item.price) || 0), 0)
        .toFixed(2)
    );
    const projectBudget = (parseFloat(state.project_budget) || 0).toFixed(2);
    if (
      !state.name ||
      !state.owner_mail ||
      // !state.project_budget ||
      (!state.month && !state.date) ||
      !state.address ||
      !state.city ||
      !state.owner_names ||
      !state.phone ||
      !state.state ||
      !state.zip
    ) {
      setEmptyFields(true);
      toast.error("Please fill the highlighted fields.");
      setActiveStep(0);
      // setEmptyFields(false);
    } else if (selectedPdf === null) {
      if (activeStep === 0) {
        setActiveStep(1);
        setEmptyFields(false);

        return;
      } else toast.error("Contract needs to be uploaded to save project.");
    } else if (
      inputList.filter(
        (x) =>
          x.price === "" ||
          x.price === "0" ||
          x.Milestone === "" ||
          x.description === ""
      ).length > 0
    ) {
      const emptyCount = inputList.filter(
        (x) => x.price === "" || x.Milestone === "" || x.description === ""
      ).length;
      const mileamount = inputList.filter((x) => x.price === "0").length;
      if (activeStep === 0) {
        setActiveStep(1);
        return;
      }
      if (activeStep === 1) setEmptyFields(true);
      if (activeStep === 1) {
        if (emptyCount > 0) {
          toast.error(
            `Please provide details for the  ${emptyCount} incomplete milestone(s).`
          );
        } else {
          if (mileamount > 0) {
            toast.error(
              `Please enter a valid, non-zero amount for the ${mileamount} incomplete milestone(s).`
            );
          }
        }
      }
    }
    // Duplicate Milestone Validation
    else if (
      inputList.some((milestone, index) => {
        const milestoneNames = inputList.map((item, i) => ({
          name: item.Milestone,
          index: i,
        }));
        const isDuplicate = milestoneNames.some(
          (item, i) =>
            item.name === milestone.Milestone.trim() &&
            item.name !== "" &&
            i !== index
        );

        if (isDuplicate) {
          setDuplicateError((prev) => ({
            ...prev,
            [index]: `Duplicate milestone found`,
          }));
        } else {
          setDuplicateError({});
        }

        return isDuplicate; // Prevent form submission if duplicates exist
      })
    ) {
      toast.error(
        "Duplicate milestone names found. Please ensure all milestone names are unique."
      );
    } else if (totalPrice > projectBudget) {
      if (activeStep === 1) {
        toast.error(
          `The sum of milestone amounts ($${totalPrice}) can't exceed the project budget of $${projectBudget}.`
        );
      }
      setActiveStep(1);
    } else if (
      projectList.some(
        (proj) => proj.name.toLowerCase() === state.name.toLowerCase()
      )
    ) {
      setProjectUniqueError(
        "Project name already exists. Please choose a different name."
      );
    } else {
      setAImessage(false);

      if (activeStep === 0) {
        setActiveStep(1);
        return;
      }

      if (activeStep === 1) {
        setActiveStep(2);
        return;
      }
      try {
        if (pdfmilestone) {
          const formData = new FormData();
          formData.set("name", state.name.trim());
          formData.set("email", state.owner_mail.trim());
          formData.set("budget", state.project_budget);
          formData.set("duration_months", state.month || 0);
          formData.set("duration_days", state.date || 0);
          formData.set("user_name", state.owner_names.trim());
          formData.set("contact_info", state.phone);
          formData.set("address", state.address.trim());
          formData.set("city", state.city.trim());
          formData.set("state", state.state.trim());
          formData.set("zip_code", state.zip);
          formData.set("co_owner_name", state.Co_owner.trim());

          if (projectFiles.length > 0) {
            projectFiles.forEach((file) => {
              formData.append("files", file.originalFile);
            });
          }

          if (selectedPdf) {
            formData.set("pdf_path", selectedPdf);
          }
          // formData.set("milestone_details", JSON.stringify(inputList));

          formData.set(
            "milestone_details",
            JSON.stringify(
              inputList.map((milestone, idx) => ({
                ...milestone,
                file_id: `milestone_files_${idx + 1}`,
              }))
            )
          );

          // Append Files Using Index
          inputList.forEach((milestone, index) => {
            milestone?.files?.forEach((file) => {
              formData.append(`milestone_files_${index + 1}`, file.file); // Use index as key
            });
          });

          setLoader(true);
          const response = await axios.post("/cvault/new-project/", formData, {
            headers: headers,
          });

          setLoader(false);
          setSelectedPdf(null);
          setSelectedPdfFile(null);
          toast.success(
            "Project added successfully and Contract submitted to Owner for approval"
          );
          setEmptyFields(false);

          setTimeout(() => {
            navigate("/contractor");
          }, 100);
          setState({
            name: "",
            owner_mail: "",
            project_budget: "",
            month: "",
            date: "",
            address: "",
            city: "",
            state: "",
            zip: "",
            phone: "",
            owner_names: "",
            Co_owner: "",
          });
          setSelectedPdf(null);
          setProjectFileURLs([]);
          setProjectFiles([]);
          setInputList([
            { Milestone: "", price: "", description: "", files: [] },
            { Milestone: "", price: "", description: "", files: [] },
            { Milestone: "", price: "", description: "", files: [] },
          ]);
        } else {
          toast.error("Please select a valid PDF file.");
        }
      } catch (error) {
        setLoader(false);
        setEmptyFields(false);
        if (
          error.response &&
          error.response.data &&
          error.response.data.error
        ) {
          if (
            error.response.data.error ===
            "Uploaded Contract document doesn't have required Milestone/Pricing Information."
          ) {
            toast.error(error?.response?.data?.error);
          } else {
            // setState({
            //   name: "",
            //   owner_mail: "",
            //   project_budget: "",
            //   month: "",
            //   date: "",
            //   address: "",
            //   city: "",
            //   state: "",
            //   zip: "",
            //   phone: "",
            //   owner_names: "",
            //   Co_owner: "",
            // });
            // setSelectedPdf(null);
            // setSelectedPdfFile(null);
            toast.error(
              error.response.data.error ||
                "Unable to create the project. Please try again later."
            );
          }
        } else {
          toast.error("Unable to create the project. Please try again later.");
        }
      }
    }
  };

  const handleBlur = async (event) => {
    const inputValue = event.target.value;
    if (event.target.name === "owner_mail" && !validateEmail(inputValue)) {
      if (inputValue.trim() !== "") {
        // toast.error("Invalid email");
        setEmailError("Invalid Email");
        emailInputRef?.current?.focus();
        setState((prev) => ({
          ...prev,
          phone: "",
          owner_names: "",
          Co_owner: "",
        }));
      }
      setState((prev) => ({
        ...prev,
        phone: "",
        owner_names: "",
        Co_owner: "",
      }));
    } else if (
      event.target.name === "phone" &&
      !validatePhoneNumber(inputValue)
    ) {
      if (inputValue !== "") {
        // toast.error("Invalid Phone Number");
        setPhoneError("Invalid Phone Number");
      }
    } else if (event.target.name === "zip" && !validateZipCode(inputValue)) {
      // toast.error("Invalid Zip code");
      setZipError("Invalid Zip code");
    } else if (event.target.name === "date" && !validateDate(inputValue)) {
      if (inputValue !== "") {
        toast.error(" Please enter a number between 0 and 30.");
      }
    }
    if (event.target.name === "owner_mail" && validateEmail(inputValue)) {
      try {
        var response = await axios.get(
          `/cvault/user-existance/?email=${inputValue}`
        );

        if (response.data.result) {
          setState((prev) => ({
            ...prev,
            phone: response?.data?.data?.contact_info || "",
            owner_names: response?.data?.data?.user_name || "",
            // address: response?.data?.data?.address || "",
            // city: response?.data?.data?.city || "",
            // state: response?.data?.data?.state || "",
            // zip: response?.data?.data?.zip_code || "",
            // address: "",
            // city: "",
            // state: "",
            // zip: "",
            Co_owner: response?.data?.data?.co_owner_name || "",
          }));
        } else {
          setState((prev) => ({
            ...prev,
            phone: "",
            owner_names: "",
            // address: "",
            // city: "",
            // state: "",
            // zip: "",
            Co_owner: "",
          }));
          setEmailError("User doesn't exist. Contact ClearVault trustee.");
          emailInputRef?.current?.focus();
        }
      } catch (error) {
        toast.error("Please try again later");
        setState((prev) => ({
          ...prev,
          phone: "",
          owner_names: "",
          // address: "",
          // city: "",
          // state: "",
          // zip: "",
          Co_owner: "",
        }));
      }
    }
  };

  const validateDate = (date) => {
    const parsedDate = parseInt(date, 10);
    return !isNaN(parsedDate) && parsedDate >= 0 && parsedDate <= 30;
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validatePhoneNumber = (phone) => {
    if (phone && typeof phone === "string") {
      return /^\d{10}$/.test(phone);
    }
    return false;
  };

  const validateZipCode = (zip) => {
    const zipCodeRegex = /^\d{5}$/;
    return zipCodeRegex.test(zip);
  };

  const milestonepdfs = (file) => {
    const pdfUrl = URL.createObjectURL(file);
    setSelectedPdfFile(pdfUrl);
  };

  const getGenAI = async () => {
    try {
      var pData = await axios.get("/cvault/genai-status/");
      setGenAI(pData?.data?.genai_status);
    } catch (error) {
      toast.error("Please try again later");
    }
  };

  // useEffect(() => {
  //   getGenAI();
  // }, []);

  useEffect(() => {
    if (selectedPdfFile != null) {
      setTimeout(() => {
        const ele = document.getElementById("expandOfProject");
        if (ele) {
          document
            .getElementById("expandOfProject")
            .scrollIntoView({ block: "center", behavior: "smooth" });
          document.getElementById("expandOfProject").style.scrollMarginTop =
            "10px";
        }
      }, 100);
    }
  }, [selectedPdfFile]);

  const steps = ["Project Details", "Upload Contract", "Project Artifacts"];

  return (
    <div className="App">
      <div className={`app-container ${loader ? "loader-container" : ""}`}>
        {loader && (
          <>
            <div className="loader-overlay">
              {AImessage && (
                <span className="loader-message">
                  AI is working on fetching the Milestone details from the
                  uploaded Contract. Please wait...
                </span>
              )}
              {!AImessage &&
                ProjectFileURLs.filter((v) => v?.type === "video").length >
                  0 && (
                  <span className="loader-message">
                    Large file detected, this may take some time...
                  </span>
                )}
              <BarLoader
                color="#F5AE41"
                width={400}
                height={10}
                className="loader"
                loading={loader}
              />
            </div>
          </>
        )}
      </div>
      <div className="d-flex justify-content-between">
        <h4 className="mt-4 ms-4 fw-bold">Add Project</h4>
        <div className="text-end mt-4 me-4 ">
          <Tooltip title="Home" placement="left" arrow>
            <button
              className="btn detail-btn me-2 "
              onClick={() => {
                setSelectedPdf(null);
                setPdfmilestone([]);
                navigate("/contractor");
              }}
              style={{
                backgroundColor: "white",
                fontWeight: 600,
                fontSize: "16px",
              }}
            >
              <Home
                onClick={() => {
                  setSelectedPdf(null);
                  setPdfmilestone([]);
                  navigate("/contractor");
                }}
                style={{ color: "rgb(72, 146, 255)" }}
              />
              {/* Back */}
            </button>
          </Tooltip>

          {/* <button
            className="btn btn-cvault"
            disabled={
              emailError !== "" ||
              projectUniqueError !== "" ||
              phoneError !== "" ||
              zipError !== ""
              // ||
              // state.name === "" ||
              // state.owner_mail === "" ||
              // state.project_budget === "" ||
              // (!state.month && !state.date) ||
              // state.address === "" ||
              // state.phone === ""
            }
            onClick={handleSubmit}
          >
            Submit
          </button> */}
        </div>
      </div>

      <Box sx={{ width: "100%" }}>
        <Stepper
          sx={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            px: 0, // remove side padding
          }}
          activeStep={activeStep}
          alternativeLabel
          connector={<CustomConnector />}
        >
          {steps.map((label, index) => {
            const isCompleted = activeStep > index;
            const isActive = activeStep === index;

            return (
              <Step
                key={index}
                completed={isCompleted}
                sx={{ flex: 1, position: "relative" }} // 👈 this line forces each step to grow equally
              >
                <StepLabel
                  sx={{
                    zIndex: 1,
                    width: index === 0 ? "50%" : index === 1 ? "100%" : "150%",
                  }}
                  StepIconComponent={() => (
                    <Tooltip arrow>
                      <Box
                        // onClick={() => setActiveStep(index)}
                        sx={{
                          width: 24,
                          height: 24,
                          borderRadius: "50%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          backgroundColor: isCompleted
                            ? "rgb(245, 174, 65)"
                            : "white",
                          color: isCompleted
                            ? "white"
                            : isActive
                            ? "rgb(245, 174, 65)"
                            : "grey.600",
                          fontWeight: 600,
                          fontSize: 14,
                          boxShadow: 1,
                          border: `2px solid ${
                            isCompleted || isActive
                              ? "rgb(245, 174, 65)"
                              : "lightgray"
                          }`,
                          cursor: "pointer",
                          marginBottom: "4px", // for spacing from label
                        }}
                      >
                        {isCompleted ? (
                          <CheckIcon style={{ fontSize: "18px" }} />
                        ) : (
                          ""
                        )}
                      </Box>
                    </Tooltip>
                  )}
                >
                  <span
                    // component="span"
                    style={{
                      fontSize: 13,
                      fontWeight: "bold",
                      marginTop: "-10px",
                    }}
                  >
                    {label}
                  </span>
                </StepLabel>
              </Step>
            );
          })}
        </Stepper>
      </Box>

      <div className="card p-3 card-cvault mt-4 ms-4 me-4 mb-5">
        {activeStep === 0 && (
          <div className="">
            <h5>
              {" "}
              <label> Project Details</label>
            </h5>
            <div className="row">
              <div className="col-md-9">
                <div className="form-group">
                  <label for="projectname">
                    Project Name<span className="text-danger fs-4">*</span>
                  </label>
                  <input
                    ref={projectNameInputRef}
                    type="text"
                    name="name"
                    className="form-control"
                    id="firstName"
                    placeholder="Project name"
                    value={state.name}
                    style={{
                      border: emptyFields && !state.name ? "1px solid red" : "",
                    }}
                    onChange={handleChange}
                    onBlur={(e) => {
                      handleUniquePrjName(e.target.value);
                    }}
                    maxLength={200}
                  />
                  {projectUniqueError && (
                    <p className="text-danger" style={{ fontSize: "12px" }}>
                      {projectUniqueError}
                    </p>
                  )}
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label for="projectduration">
                    {" "}
                    Project Duration<span className="text-danger fs-4">*</span>
                  </label>
                  <div className="d-flex ">
                    <input
                      type="number"
                      value={state.month}
                      className="form-control"
                      onChange={handleChange}
                      name="month"
                      min="1"
                      required
                      placeholder="Months"
                      onKeyPress={(e) => {
                        // Allow only digits (0-9) and prevent non-numeric input
                        if (!/[0-9]/.test(e.key)) {
                          e.preventDefault(); // Prevent input if it's not a number
                        }
                      }}
                      // style={{
                      //   border:
                      //     emptyFields && !state.month && !state.date
                      //       ? "1px solid red"
                      //       : "",
                      // }}
                    />
                    {/* <span className="ms-2 mt-2 text-muted">months</span> */}
                    <input
                      type="number"
                      name="date"
                      className="form-control ms-2"
                      value={state.date}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      onKeyPress={(e) => {
                        // Allow only digits (0-9) and prevent non-numeric input
                        if (!/[0-9]/.test(e.key)) {
                          e.preventDefault(); // Prevent input if it's not a number
                        }
                      }}
                      min="0"
                      max="30"
                      required
                      placeholder="Days"
                      style={{
                        border:
                          emptyFields && !state.month && !state.date
                            ? "1px solid red"
                            : "",
                      }}
                    />
                    {/* <span className="ms-2 mt-2 text-muted">days</span> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="row ">
              <div className="col-md-3 ">
                <div className="form-group">
                  <label for="ownermail">
                    Owner Email<span className="text-danger fs-4">*</span>
                  </label>
                  {/* <input
                    ref={emailInputRef}
                    type="text"
                    name="owner_mail"
                    className="form-control"
                    placeholder="Owner mail"
                    value={state.owner_mail.trim()}
                    onChange={(e) => {
                      handleChange(e);
                      setEmailError("");
                    }}
                    onBlur={handleBlur}
                    style={{
                      border:
                        emptyFields && !state.owner_mail ? "1px solid red" : "",
                    }}
                  /> */}
                  <select
                    // ref={emailInputRef}
                    name="owner_mail"
                    className="form-control"
                    value={state.owner_mail.trim()}
                    onChange={(e) => {
                      handleChange(e);
                      setEmailError("");
                      handleBlur(e);
                    }}
                    // onBlur={handleBlur}
                    style={{
                      border:
                        emptyFields && !state.owner_mail ? "1px solid red" : "",
                      marginTop: "2px",
                    }}
                  >
                    <option value="">Select Owner Email</option>
                    {ownerOptions.map((owner, index) => (
                      <option key={index} value={owner.email || owner}>
                        {owner.email || owner}
                      </option>
                    ))}
                  </select>
                  {emailError && (
                    <label className="text-danger" style={{ fontSize: "14px" }}>
                      {emailError}
                    </label>
                  )}
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label for="ownermail">
                    Owner Name
                    <span className="text-danger fs-4"></span>
                  </label>
                  <input
                    type="text"
                    name="owner_names"
                    className="form-control"
                    id="firstName"
                    placeholder="Owner name"
                    value={state.owner_names}
                    onChange={handleChange}
                    // style={{
                    //   border:
                    //     emptyFields && !state.owner_names
                    //       ? "1px solid red"
                    //       : "",
                    // }}
                    disabled={true}
                  />
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group ">
                  <label for="ownermail">
                    Co-Owner Name
                    <span className="text-danger fs-4"></span>
                  </label>

                  <input
                    type="text"
                    name="Co_owner"
                    className="form-control"
                    id="firstName"
                    placeholder="Co-Owner name"
                    value={state.Co_owner}
                    onChange={handleChange}
                    disabled={true}
                  />
                </div>
              </div>
              <div className="col-md-3 ">
                <div className="form-group">
                  <label for="ownermail">
                    Phone<span className="text-danger fs-4"></span>
                  </label>
                  <input
                    type="text"
                    name="phone"
                    className="form-control"
                    placeholder="Phone"
                    value={state.phone}
                    onChange={(e) => {
                      handleChange(e);
                      setPhoneError("");
                    }}
                    onBlur={handleBlur}
                    // style={{
                    //   border:
                    //     emptyFields && !state.phone ? "1px solid red" : "",
                    // }}
                    disabled={true}
                  />
                  {phoneError && (
                    <label className="text-danger" style={{ fontSize: "14px" }}>
                      {phoneError}
                    </label>
                  )}
                </div>
              </div>
            </div>
            <div className="row ">
              <div className="col-md-3">
                <div className="form-group">
                  <label for="projectname">
                    Site Address<span className="text-danger fs-4">*</span>
                  </label>
                  <input
                    type="text"
                    name="address"
                    className="form-control"
                    id="firstName"
                    placeholder="Address"
                    value={state.address}
                    onChange={handleChange}
                    style={{
                      border:
                        emptyFields && !state.address ? "1px solid red" : "",
                    }}
                    maxLength={100}
                  />
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label for="projectname">
                    City<span className="text-danger fs-4">*</span>
                  </label>
                  <input
                    type="text"
                    name="city"
                    className="form-control"
                    id="firstName"
                    placeholder="City"
                    value={state.city}
                    onChange={handleChange}
                    style={{
                      border: emptyFields && !state.city ? "1px solid red" : "",
                    }}
                    onKeyPress={(e) => {
                      if (/[0-9]/.test(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    maxLength={100}
                  />
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label for="projectname">
                    State<span className="text-danger fs-4">*</span>
                  </label>
                  <input
                    type="text"
                    name="state"
                    className="form-control"
                    id="firstName"
                    placeholder="State"
                    value={state.state}
                    onChange={handleChange}
                    style={{
                      border:
                        emptyFields && !state.state ? "1px solid red" : "",
                    }}
                    onKeyPress={(e) => {
                      if (/[0-9]/.test(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    maxLength={100}
                  />
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label for="projectname">
                    Zip<span className="text-danger fs-4">*</span>
                  </label>
                  <input
                    type="number"
                    name="zip"
                    className="form-control"
                    id="firstName"
                    placeholder="Zip"
                    value={state.zip}
                    onChange={(e) => {
                      handleChange(e);
                      setZipError("");
                    }}
                    onKeyPress={(e) => {
                      // Allow only digits (0-9) and prevent non-numeric input
                      if (!/[0-9]/.test(e.key)) {
                        e.preventDefault(); // Prevent input if it's not a number
                      }
                    }}
                    onBlur={handleBlur}
                    style={{
                      border: emptyFields && !state.zip ? "1px solid red" : "",
                    }}
                  />
                  {zipError && (
                    <label className="text-danger" style={{ fontSize: "14px" }}>
                      {zipError}
                    </label>
                  )}
                </div>
              </div>
            </div>

            {/* <div>
              {errorMsg !== "" && (
                <span style={{ color: "red" }}>{errorMsg}</span>
              )}
            </div> */}
          </div>
        )}
        {activeStep === 1 && (
          <div>
            <div className="">
              <div
                className="d-flex align-items-center justify-content-between"
                style={{ marginTop: "-10px" }}
              >
                <div>
                  <h5 className="">
                    Contract Details<span className="text-danger  fs-4">*</span>
                    {selectedPdf && (
                      <span
                        className="text-primary"
                        style={{ fontWeight: 400 }}
                      >
                        <span className="fs-6"> ({fileName})</span>
                      </span>
                    )}
                  </h5>
                </div>
                <div className="d-flex me-4">
                  {" "}
                  <div class="aliens d-flex mt-2 ">
                    <span>G</span>
                    <span>E</span>
                    <span>N</span>
                    <span>-</span>
                    <span>A</span>
                    <span>I</span>
                  </div>
                  <Switch
                    checked={genAI}
                    onChange={genAIChange}
                    color="success"
                    className="ms-1"
                  />
                </div>
              </div>

              <div
                className="inspector-drag-area mt-2 px-5"
                style={{ marginLeft: "0%", marginRight: "0%" }}
              >
                <label
                  htmlFor="pdfFile"
                  className="text-center m-auto bg-white w-50 cursor"
                  onClick={(e) => {
                    // if (
                    //   state.name !== "" &&
                    //   state.owner_mail !== "" &&
                    //   state.project_budget !== "" &&
                    //   (state.month !== "" || state.date !== "") &&
                    //   state.address !== "" &&
                    //   state.phone !== ""
                    // ) {
                    //   setErrorMsg("");
                    // } else {
                    //   e.preventDefault();
                    // }
                  }}
                >
                  <>
                    <div
                      class="icon"
                      style={{
                        color: "#f5ae41",
                        // state.name !== "" &&
                        // state.owner_mail !== "" &&
                        // state.project_budget !== "" &&
                        // (state.month !== "" || state.date !== "") &&
                        // state.address !== "" &&
                        // state.phone !== ""
                        //   ? "#f5ae41"
                        //   : "lightgray",
                      }}
                    >
                      <i class="fas fa-cloud-upload-alt"></i>
                    </div>
                    <input
                      type="file"
                      id="pdfFile"
                      key={selectedPdf ? selectedPdf.name : "defaultKey"}
                      name="pdfFile"
                      accept="application/pdf"
                      // ref={ContractRef} // Reference for clicking programmatically
                      onChange={handleFileChange}
                      multiple
                      style={{ display: "none" }}
                    />

                    <>
                      <header> Upload Contract</header>
                    </>
                  </>
                </label>
              </div>
            </div>
            <div className="row mb-1" id="expandOfProject">
              <div className="col-md-6  mt-3">
                {selectedPdfFile && (
                  <iframe
                    title="PDF Viewer"
                    style={iframeStyle}
                    src={selectedPdfFile}
                  />
                )}
              </div>
              <div
                className={
                  selectedPdfFile !== null ? "col-md-6 mt-3" : "col-md-12 mt-3"
                }
                style={{
                  display: selectedPdfFile !== null ? "" : "none",
                  height: "100vh",
                  overflow: "scroll",
                }}
              >
                <div className="d-flex align-items-center justify-content-between">
                  <span className=" fs-5">Milestone(s)</span>
                  <div className="form-group d-flex align-items-center">
                    <label for="budget" className="d-flex align-items-center">
                      {" "}
                      <span className="me-2 fs-5">Project</span>{" "}
                      <span className="fs-5 me-1"> Budget</span>
                      {/* <span className="text-danger fs-4 me-1">*</span>{" "} */}
                    </label>
                    <TextField
                      style={{
                        border:
                          // emptyFields && !state.project_budget
                          //   ? "1px solid red"
                          //   :
                          "1px solid lightgray",
                        borderBottom: "0px !important",
                        outline: "none",
                      }}
                      className="budgetinput form-control mt-1"
                      value={state.project_budget}
                      onChange={handleChange}
                      name="project_budget"
                      id="formatted-numberformat-input"
                      InputProps={{
                        inputComponent: NumericFormatCustom,
                        sx: {
                          color: "#0d6efd", // ✅ This changes the input text color
                        },
                      }}
                      variant="standard"
                      disabled={true}
                    />
                  </div>
                </div>
                {inputList?.map((x, i) => (
                  <div className="box" key={i}>
                    <div className="d-flex justify-content-between">
                      <div className="d-flex">
                        <p className="mt-2">{i + 1}</p>
                        <span className="mt-2">:</span>
                        <input
                          value={x.Milestone}
                          onChange={(e) => handleInputChange(e, i)}
                          onBlur={(e) => handleDulpicateCheck(e, i)}
                          name="Milestone"
                          placeholder="Milestone Name"
                          className="ms-1 mt-1"
                          style={{
                            height: "38px",
                            width: "auto",
                            borderRadius: "6px",
                            border:
                              emptyFields && !x.Milestone
                                ? "1px solid red"
                                : "1px solid lightgrey",
                          }}
                          maxLength={100}
                        />
                      </div>
                      <div className="d-flex">
                        <label className="me-2 mt-2">Amount</label>
                        <TextField
                          style={{
                            border: "1px solid lightgray",
                            outline: "none",
                            height: "34px",
                            border:
                              emptyFields &&
                              (x.price === "" ||
                                x.price === 0 ||
                                x.price === "0")
                                ? "1px solid red"
                                : "1px solid lightgrey",
                          }}
                          className="budgetinput form-control mt-1"
                          value={x.price}
                          onChange={(e) => handleInputChange(e, i)}
                          name="price"
                          InputProps={{ inputComponent: NumericFormatCustom }}
                          variant="standard"
                        />
                      </div>
                    </div>

                    {duplicateError[i] && (
                      <label
                        className="text-danger ms-3"
                        style={{ fontSize: "14px" }}
                      >
                        {duplicateError[i]}
                      </label>
                    )}

                    <textarea
                      name="description"
                      className="mt-2 ms-3"
                      style={{
                        height: "100px",
                        width: "98%",
                        borderRadius: "6px",
                        border:
                          emptyFields && !x.description
                            ? "1px solid red"
                            : "1px solid lightgrey",
                      }}
                      placeholder="Description"
                      value={x.description}
                      onChange={(e) => handleInputChange(e, i)}
                    />

                    {/* Upload Button */}
                    <div className="d-flex align-items-center w-100">
                      <div className="ps-4">
                        <Tooltip placement="right" title="">
                          <div
                            style={{
                              // width: "10rem",
                              // padding: "7px",
                              cursor: "pointer",
                              // background: "linear-gradient(135deg, #F5AE41, #F87E02)",
                              borderRadius: "16px",
                              // boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px",
                              color: "#4892ff",
                            }}
                            className="d-flex align-items-center"
                            onClick={() => handleMilestoneFileClick(i)}
                          >
                            <i
                              class="fas fa-cloud-upload-alt"
                              style={{ fontSize: "22px" }}
                            ></i>
                            <span style={{ fontSize: 14 }} className="ms-1">
                              Milestone
                            </span>
                            <span style={{ fontSize: 14 }} className="ms-1">
                              Documents
                            </span>
                            {/* <img
                          src={UploadImg}
                          style={{ width: "35px" }}
                          alt="upload documents"
                        /> */}

                            {/* <AddCircleIcon sx={{ fontSize: "18px" }} /> */}
                            {/* <span style={{ fontSize: 14 }} className="ms-1">
                          {" "}
                          Add Documents
                        </span> */}
                            {/* <AddIcon/> */}
                            <input
                              type="file"
                              multiple
                              ref={(el) => (fileInputRefs.current[i] = el)}
                              style={{ display: "none" }}
                              onChange={(e) => handleMilestoneFileUpload(e, i)}
                            />
                          </div>
                        </Tooltip>
                      </div>
                      <div className="d-flex align-items-center justify-content-between w-100">
                        {/* File Previews */}
                      </div>
                      {/* Buttons */}
                      <div className="btn-box mt-2 d-flex justify-content-end">
                        {inputList.length !== 1 && (
                          <Tooltip title="Remove Milestone" placement="left">
                            <button
                              className="mr10 btn detail-btn ms-3 d-flex align-items-center"
                              // style={{background:'none'}}
                              onClick={() => handleRemoveClick(i)}
                            >
                              {" "}
                              <CloseIcon
                                style={{ fontSize: "16px", fontWeight: 400 }}
                              />
                              <span className="ms-1">Remove</span>
                            </button>
                          </Tooltip>
                        )}
                        {inputList.length - 1 === i && (
                          <button
                            className="btn btn-cvault ms-2 text-white d-flex align-items-center"
                            onClick={handleAddClick}
                            style={{
                              fontSize: "14px",
                              fontWeight: 400,
                              background: "rgb(72, 146, 255)",
                            }}
                          >
                            <AddCircleOutlineIcon
                              style={{ fontSize: "16px", fontWeight: 400 }}
                            />
                            <span className="ms-1">Milestone</span>
                          </button>
                        )}
                      </div>
                    </div>
                    <div
                      className="ps-3"
                      style={{ display: "flex", gap: "2px", flexWrap: "wrap" }}
                    >
                      {(showAll ? x?.files : x?.files?.slice(0, 5))?.map(
                        (file, index) => {
                          let icon;
                          switch (file.type) {
                            case "image":
                              icon = (
                                <ImageIcon
                                  style={{ fontSize: 24, color: "#F5AE41" }}
                                />
                              );
                              break;
                            case "video":
                              icon = (
                                <VideoLibraryIcon
                                  style={{ fontSize: 24, color: "#F5AE41" }}
                                />
                              );
                              break;
                            case "pdf":
                              icon = (
                                <PictureAsPdfIcon
                                  style={{ fontSize: 24, color: "#F5AE41" }}
                                />
                              );
                              break;
                            case "text":
                              icon = (
                                <DescriptionIcon
                                  style={{ fontSize: 24, color: "#F5AE41" }}
                                />
                              );
                              break;
                            default:
                              icon = (
                                <InsertDriveFileIcon
                                  style={{ fontSize: 24, color: "#F5AE41" }}
                                />
                              );
                          }

                          return (
                            <Tooltip
                              key={index}
                              title={`Click to ${
                                file.type === "others" ? "download " : "view"
                              } ${file.name}`}
                            >
                              <div
                                style={{
                                  display: "inline-block",
                                  textAlign: "center",
                                  marginRight: 15,
                                  position: "relative",
                                  cursor: "pointer",
                                }}
                                className="mt-2"
                                onClick={() => {
                                  setMilestoneFileIndex(i + 1);
                                  if (
                                    ["image", "text", "pdf", "video"].includes(
                                      file.type
                                    )
                                  ) {
                                    setSelectedContractMilestoneFile(file.url); // Set the selected file URL
                                    setContractMilestoneFile(true); // Open the modal
                                  } else {
                                    const link = document.createElement("a");
                                    link.href = file.url;
                                    link.download = file.name; // Set file name for download
                                    document.body.appendChild(link);
                                    link.click();
                                    document.body.removeChild(link);
                                  }
                                }}
                              >
                                {/* Remove Button */}
                                <div
                                  style={{
                                    width: "fit-content",
                                    cursor: "pointer",
                                    position: "absolute",
                                    top: "-8px",
                                    right: "7px",
                                  }}
                                  onClick={(e) => {
                                    e.stopPropagation(); // Prevent triggering the modal when clicking remove
                                    handleMilestoneRemoveFile(i, file.name);
                                  }}
                                >
                                  <CloseIcon
                                    style={{
                                      backgroundColor: "#898989",
                                      borderRadius: "50%",
                                      fontSize: "10px",
                                      color: "#fff",
                                    }}
                                  />
                                </div>

                                {/* File Icon & Link */}
                                <div>
                                  <div
                                  // href={file.url}
                                  // target="_blank"
                                  // rel="noopener noreferrer"
                                  >
                                    {icon}
                                  </div>
                                  <Typography fontSize={12}>
                                    {file.name.slice(0, 3)}...
                                    {file.name.slice(-3)}
                                  </Typography>
                                </div>
                              </div>
                            </Tooltip>
                          );
                        }
                      )}

                      {/* View More / View Less Button */}
                      {x?.files?.length > 5 && (
                        <>
                          <div
                            onClick={() => setShowAll(!showAll)}
                            size="small"
                            style={{
                              marginLeft: 10,
                              fontSize: "12px",
                              textTransform: "none",
                              cursor: "pointer",
                              color: "#4892ff",
                            }}
                            className="mt-4"
                          >
                            {showAll ? "View Less" : "View All"}
                          </div>
                          {/* <div style={{height:'20px',width:'20px',backgroundColor:'grey'}}>+{x?.files?.length - 5 }</div> */}
                        </>
                      )}
                    </div>
                    <Divider
                      className="my-2 ms-3"
                      style={{ color: "#efeaee" }}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {activeStep === 2 && (
          <div className="">
            {/* {selectedPdf && (
          <p className=" mt-3">
            Uploaded Contract:
            <span className="text-danger"> {fileName}</span>
          </p>
        )} */}
            <h5>
              {" "}
              <label> Additional Project Artifacts</label>
            </h5>
            <div className="d-flex align-items-center">
              {/* {ProjectFileURLs.length > 0 && <label>Additional Documents: </label>} */}

              <div
                className=""
                style={{ display: "flex", flexWrap: "wrap", gap: "7px" }}
              >
                {(proshowAll
                  ? ProjectFileURLs
                  : ProjectFileURLs?.slice(0, 20)
                )?.map((file, index) => {
                  let icon;
                  switch (file.type) {
                    case "image":
                      icon = (
                        <ImageIcon style={{ fontSize: 24, color: "#F5AE41" }} />
                      );
                      break;
                    case "video":
                      icon = (
                        <VideoLibraryIcon
                          style={{ fontSize: 24, color: "#F5AE41" }}
                        />
                      );
                      break;
                    case "pdf":
                      icon = (
                        <PictureAsPdfIcon
                          style={{ fontSize: 24, color: "#F5AE41" }}
                        />
                      );
                      break;
                    case "text":
                      icon = (
                        <DescriptionIcon
                          style={{ fontSize: 24, color: "#F5AE41" }}
                        />
                      );
                      break;
                    default:
                      icon = (
                        <InsertDriveFileIcon
                          style={{ fontSize: 24, color: "#F5AE41" }}
                        />
                      );
                  }

                  return (
                    <Tooltip
                      key={index}
                      title={`Click to ${
                        file.type === "others" ? "download " : "view"
                      } ${file.name}`}
                    >
                      <div
                        style={{
                          display: "inline-block",
                          textAlign: "center",
                          position: "relative",
                          cursor: "pointer",
                        }}
                        className="mt-2"
                        onClick={() => {
                          if (
                            ["image", "text", "pdf", "video"].includes(
                              file.type
                            )
                          ) {
                            setSelectedContractDoc(file.url); // Set the selected file URL
                            setContractDocuments(true); // Open the modal
                          } else {
                            const link = document.createElement("a");
                            link.href = file.url;
                            link.download = file.name; // Set file name for download
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                          }
                        }}
                      >
                        {/* Remove Button (X) */}
                        {/* <Tooltip title="click to remove"> */}
                        <div
                          style={{
                            width: "fit-content",
                            cursor: "pointer",
                            position: "absolute",
                            top: "-8px",
                            right: "7px",
                          }}
                          onClick={(e) => {
                            e.stopPropagation(); // Prevent triggering the modal when clicking remove
                            handleProjectRomoveFile(file.name);
                          }}
                        >
                          <CloseIcon
                            style={{
                              backgroundColor: "#898989",
                              borderRadius: "50%",
                              fontSize: "10px",
                              color: "#fff",
                            }}
                          />
                        </div>
                        {/* </Tooltip> */}
                        {/* File Icon & Link */}
                        <div
                        // href={file.url}
                        // target="_blank"
                        // rel="noopener noreferrer"
                        >
                          {icon}
                        </div>
                        {/* File Name (Shortened) */}
                        <Typography fontSize={12}>
                          {file.name.slice(0, 3)}...{file.name.slice(-3)}
                        </Typography>{" "}
                      </div>
                    </Tooltip>
                  );
                })}
                {ProjectFileURLs.length > 20 && (
                  <>
                    <div
                      onClick={() => setProShowAll(!proshowAll)}
                      size="small"
                      style={{
                        marginLeft: 10,
                        fontSize: "12px",
                        textTransform: "none",
                        cursor: "pointer",
                        color: "#4892ff",
                      }}
                      className="mt-4"
                    >
                      {proshowAll ? "View Less" : "View All"}
                    </div>
                  </>
                )}
              </div>
            </div>
            {/* {selectedPdf !== null && (
              <Tooltip placement="left" title="Additional documents">
                <div
                  style={{
                    width: "fit-content",
                    padding: "7px",
                    cursor: "pointer",

                    borderRadius: "16px",
                    color: "#4892ff",
                    marginTop: "5px",
                  }}
                  className="d-flex align-items-center me-1"
                  onClick={handleProjectFileClick}
                >
                  <i
                    class="fas fa-cloud-upload-alt"
                    style={{ fontSize: "24px" }}
                  ></i>

                  
                  <input
                    type="file"
                    ref={fileInputRef}
                    multiple
                    style={{ display: "none" }}
                    onChange={handleProjectFileUpload}
                  />
                </div>
              </Tooltip>
            )} */}
            <div
              className="inspector-drag-area  px-5 mt-2 mb-2"
              style={{ marginLeft: "0%", marginRight: "0%" }}
            >
              <label
                htmlFor="pdfFile"
                className="text-center m-auto bg-white w-50 cursor"
                // onClick={(e) => {
                // if (
                //   state.name !== "" &&
                //   state.owner_mail !== "" &&
                //   state.project_budget !== "" &&
                //   (state.month !== "" || state.date !== "") &&
                //   state.address !== "" &&
                //   state.phone !== ""
                // ) {
                //   setErrorMsg("");
                // } else {
                //   e.preventDefault();
                // }
                onClick={handleProjectFileClick}

                // }}
              >
                <>
                  <div
                    class="icon"
                    style={{
                      color: "#f5ae41",
                      // state.name !== "" &&
                      // state.owner_mail !== "" &&
                      // state.project_budget !== "" &&
                      // (state.month !== "" || state.date !== "") &&
                      // state.address !== "" &&
                      // state.phone !== ""
                      //   ? "#f5ae41"
                      //   : "lightgray",
                    }}
                  >
                    <i class="fas fa-cloud-upload-alt"></i>
                  </div>
                  <input
                    type="file"
                    ref={fileInputRef}
                    multiple
                    style={{ display: "none" }}
                    onChange={handleProjectFileUpload}
                  />

                  <>
                    <header>Additional Project Artifacts</header>
                    <p
                      style={{
                        fontSize: "14px",
                        color: "gray",
                        marginBottom: "5px",
                      }}
                    >
                      Maximum file size: 200MB
                    </p>
                  </>
                </>
              </label>
            </div>
          </div>
        )}

        <div
          className={`d-flex align-items-center ${
            activeStep !== 0 ? "mt-2" : ""
          }`}
        >
          {activeStep !== 0 ? (
            <button
              className="btn detail-btn me-2 "
              style={{
                backgroundColor: "lightgray",
                fontWeight: 600,
                fontSize: "16px",
              }}
              onClick={() => {
                setActiveStep((pre) => pre - 1);
              }}
            >
              Previous
            </button>
          ) : (
            <div />
          )}
          <div className="d-flex align-items-center justify-content-end w-100">
            {/* {activeStep === 1 && (
              <Tooltip
                placement="left"
                title="Click to add project artifacts"
                arrow
              >
                <button
                  className="btn btn-cvault   me-3"
                  style={{ width: "10%" }}
                  onClick={() => {
                    handleSubmit("next");
                  }}
                  disabled={
                    emailError !== "" ||
                    projectUniqueError !== "" ||
                    phoneError !== "" ||
                    zipError !== ""
                    // ||
                    // state.name === "" ||
                    // state.owner_mail === "" ||
                    // state.project_budget === "" ||
                    // (!state.month && !state.date) ||
                    // state.address === "" ||
                    // state.phone === ""
                  }
                >
                  Next
                </button>
              </Tooltip>
            )} */}
            <button
              className={`btn btn-cvault  ${activeStep !== 0 ? "" : ""}`}
              style={{ width: activeStep !== 0 ? "15%" : "10%" }}
              onClick={handleSubmit}
              disabled={
                emailError !== "" ||
                projectUniqueError !== "" ||
                phoneError !== "" ||
                zipError !== ""
                // ||
                // state.name === "" ||
                // state.owner_mail === "" ||
                // state.project_budget === "" ||
                // (!state.month && !state.date) ||
                // state.address === "" ||
                // state.phone === ""
              }
            >
              {activeStep === 2 ? "Create Project" : "Next"}
            </button>
          </div>
        </div>
      </div>
      <br />

      {/* Contract Milestone File Modal */}
      <Modal
        open={ContractMilestoneFile}
        onClose={() => {
          setContractMilestoneFile(false);
          setMilestoneFileIndex(null);
          setSelectedContractMilestoneFile(null); // Reset selected document on close
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            borderRadius: "5px",
            boxShadow: 24,
            width: "70%",
            height: "90%",
            overflowY: "auto",
          }}
        >
          <div>
            {/* Modal Header */}
            <div
              style={{
                position: "sticky",
                top: "0",
                zIndex: 2,
                backgroundColor: "white",
                borderBottom: "1px solid lightgray",
              }}
              className="d-flex justify-content-between ps-4 pe-2 pt-2"
            >
              <h5>Milestone {MilestoneFileIndex} Documents</h5>
              <IoIosClose
                className="fs-1 cursor"
                onClick={() => {
                  setContractMilestoneFile(false);
                  setMilestoneFileIndex(null);
                  setSelectedContractMilestoneFile(null);
                }}
              />
            </div>

            <div style={{ padding: "0px 16px" }}>
              {selectedContractMilestoneFile && (
                <iframe
                  title="PDF Viewer"
                  style={{
                    width: "100%",
                    height: "85vh",
                    border: "none",
                  }}
                  src={selectedContractMilestoneFile}
                />
              )}
            </div>
          </div>
        </Box>
      </Modal>

      {/* Contract Documents Modal */}
      <Modal
        open={ContractDocuments}
        onClose={() => {
          setContractDocuments(false);
          setSelectedContractDoc(null); // Reset selected document on close
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            borderRadius: "5px",
            boxShadow: 24,
            width: "70%",
            height: "90%",
            overflowY: "auto",
          }}
        >
          <div>
            {/* Modal Header */}
            <div
              style={{
                position: "sticky",
                top: "0",
                zIndex: 2,
                backgroundColor: "white",
                borderBottom: "1px solid lightgray",
              }}
              className="d-flex justify-content-between ps-4 pe-2 pt-2"
            >
              <h5>Project Documents</h5>
              <IoIosClose
                className="fs-1 cursor"
                onClick={() => {
                  setContractDocuments(false);
                  setSelectedContractDoc(null);
                }}
              />
            </div>

            <div style={{ padding: "0px 16px" }}>
              {selectedContractDoc && (
                <iframe
                  title="PDF Viewer"
                  style={{
                    width: "100%",
                    height: "85vh",
                    border: "none",
                  }}
                  src={selectedContractDoc}
                />
              )}
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
}

export default Inputs;
